"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const Raw = __importStar(require("./raw"));
const U = __importStar(require("./utils"));
class CrudRequest {
    constructor(entity, url = '/crud/query', urlMutate = '/crud/mutate') {
        this.insert = (data) => __awaiter(this, void 0, void 0, function* () {
            const query = {
                [this.entity]: {
                    insert: { data }
                }
            };
            const d = yield Raw.mutate(query, this.urlMutate);
            const dd = d[this.entity];
            const out = dd.insert;
            if (out && out.success) {
                if (out.uuid) {
                    return out.uuid;
                }
                if (out.id) {
                    return out.id;
                }
                throw Error('could not retrieve id/uuid');
            }
            throw Error('could not insert record');
        });
        this.update = (data, filters) => __awaiter(this, void 0, void 0, function* () {
            const query = {
                [this.entity]: {
                    update: { data, filters }
                }
            };
            const d = yield Raw.mutate(query, this.urlMutate);
            const dd = d[this.entity];
            if (dd && dd.update && dd.update.success) {
                return true;
            }
            throw Error('could not insert permission');
        });
        this.delete = (filters) => __awaiter(this, void 0, void 0, function* () {
            const query = {
                [this.entity]: {
                    delete: {
                        filters
                    }
                }
            };
            const d = yield Raw.mutate(query, this.urlMutate);
            const dd = d[this.entity];
            if (dd && dd.delete && dd.delete.success === true) {
                return dd.delete.deleted;
            }
            throw Error('could not delete permission');
        });
        this.entity = entity;
        this.url = url;
        this.urlMutate = urlMutate;
    }
    list(params = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = { [this.entity]: params };
            const d = yield Raw.query(query, this.url);
            return d[this.entity];
        });
    }
    detail(filters, projection = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const query = U.getQuerySingleEntity(this.entity, filters, projection);
            const d = yield Raw.query(query, this.url);
            const dd = d[this.entity];
            if (dd.length) {
                return dd[0];
            }
            throw Error('could not find requested entry with uuid :' + JSON.stringify(filters));
        });
    }
}
exports.default = CrudRequest;
